import React from "react";

const PixelFormContext = React.createContext();
export default PixelFormContext;
